var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8338 9.44391H16.5986L15.7433 8.00717C15.6597 7.8667 15.5083 7.78064 15.3448 7.78064H12.6551C12.4916 7.78064 12.3402 7.8667 12.2566 8.00717L11.4013 9.44391H10.0116V9.12725C10.0116 8.87114 9.80392 8.66351 9.54782 8.66351H7.83191C7.57575 8.66351 7.36816 8.87114 7.36816 9.12725V9.44391H7.16615C6.52206 9.44391 6 9.96602 6 10.61V19.0532C6 19.6972 6.52206 20.2193 7.1661 20.2193H20.8338C21.4778 20.2193 21.9999 19.6972 21.9999 19.0532V10.61C22 9.96602 21.4778 9.44391 20.8338 9.44391ZM13.9999 18.1509C12.1667 18.1509 10.6806 16.6648 10.6806 14.8315C10.6806 12.9984 12.1667 11.5122 13.9999 11.5122C15.8332 11.5122 17.3193 12.9984 17.3193 14.8315C17.3193 16.6648 15.8332 18.1509 13.9999 18.1509ZM20.1062 11.8481H18.6531C18.397 11.8481 18.1894 11.6404 18.1894 11.3843C18.1894 11.1281 18.397 10.9205 18.6531 10.9205H20.1062C20.3625 10.9205 20.57 11.1281 20.57 11.3843C20.57 11.6404 20.3624 11.8481 20.1062 11.8481Z",
    fill: "#027CBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.1504C15.2807 17.1504 16.3189 16.1122 16.3189 14.8316C16.3189 13.5509 15.2807 12.5127 14 12.5127C12.7193 12.5127 11.6812 13.5509 11.6812 14.8316C11.6812 16.1122 12.7193 17.1504 14 17.1504Z",
    fill: "#027CBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.e4e470242da3ee66e34fa7958d93ef01.svg";
export { ForwardRef as ReactComponent };